import { useState } from 'react'
import { ModalDialog, Mtds } from 'prove-common'
import {
  getWidgetDescription,
  getWidgetSubProperties,
  getWidgetTypeIcon,
  type SchemaWidgetGroup
} from '../../schemas/schema-utils'

type SchemaElementPickerModalProps = {
  isOpen: boolean
  onClose: () => void
  availableGroups: SchemaWidgetGroup[]
  onAdd: (widgetId: string, isRequired: boolean) => void
}

export const SchemaElementPickerModal = ({
  isOpen,
  onClose,
  availableGroups,
  onAdd
}: SchemaElementPickerModalProps) => {
  const [searchText, setSearchText] = useState('')

  const filteredGroups = availableGroups.filter((group) =>
    group.title.toLowerCase().includes(searchText.toLowerCase())
  )

  return (
    <ModalDialog
      id='schema-element-picker-modal'
      closedby='any'
      open={isOpen}
      onClose={() => {
        setSearchText('')
        onClose()
      }}
    >
      <Mtds.Button
        command='close'
        commandfor='schema-element-picker-modal'
        aria-label='Lukk'
      />
      <Mtds.Grid data-gap='6'>
        <Mtds.Heading>Legg til element</Mtds.Heading>
        <Mtds.Field
          as='input'
          type='search'
          label='Søk'
          value={searchText}
          placeholder='Søk etter element'
          onChange={({ target }) => setSearchText(target.value)}
        />
        <Mtds.Grid>
          {filteredGroups.length === 0 && (
            <Mtds.Muted>
              {availableGroups.length === 0
                ? 'Alle tilgjengelige elementer er lagt til'
                : 'Ingen elementer matcher søket'}
            </Mtds.Muted>
          )}
          {filteredGroups.map((group) => {
            const widget = group.widgets[0]
            const includeInRequisition =
              widget.schema?.['x-include-in-requisition'] ?? false
            const description = getWidgetDescription(widget.schema)
            const subProperties = getWidgetSubProperties(widget.schema)
            return (
              <Mtds.Card
                key={group.id}
                as='button'
                style={{ cursor: 'pointer', width: '100%', textAlign: 'left' }}
                onClick={() => {
                  onAdd(widget.id, true)
                  onClose()
                }}
              >
                <Mtds.Grid>
                  <Mtds.Flex data-align='center' data-gap='2' data-nowrap>
                    {getWidgetTypeIcon(widget.schema)}
                    <strong>{group.title}</strong>
                    <Mtds.Tag
                      data-color={includeInRequisition ? 'success' : 'neutral'}
                      data-size='sm'
                      data-icon='none'
                    >
                      {includeInRequisition ? 'Til lab' : 'Ikke til lab'}
                    </Mtds.Tag>
                  </Mtds.Flex>
                  {description && <Mtds.Muted>{description}</Mtds.Muted>}
                  {subProperties && (
                    <Mtds.Grid data-gap='1'>
                      <Mtds.Muted>
                        <strong>Felter</strong>
                      </Mtds.Muted>
                      <Mtds.Flex data-gap='1' className='flex-wrap'>
                        {subProperties.map((p) => (
                          <Mtds.Tag
                            key={p.key}
                            data-size='sm'
                            data-icon='none'
                            data-color='neutral'
                          >
                            {p.title}
                          </Mtds.Tag>
                        ))}
                      </Mtds.Flex>
                    </Mtds.Grid>
                  )}
                </Mtds.Grid>
              </Mtds.Card>
            )
          })}
        </Mtds.Grid>
      </Mtds.Grid>
    </ModalDialog>
  )
}
